import { DocumentTemplateType } from '@dokucoach/common-types';
import * as yup from 'yup';

export const DocumentTemplateSchema = yup.object({
  type: yup.string().required(),
  information: yup.string().notRequired().nullable(),
  originDate: yup.date().required(),
});

export const DownloadDocumentTemplateSchema = yup.object({
  awsFilePath: yup.string().required(),
});

export const UpdateDocumentTemplateSchema = yup.object({
  id: yup.string(),
  type: yup.string().required(),
  information: yup.string().notRequired().nullable(),
  originDate: yup.date().required(),
  isHidden: yup.boolean().required(),
});

export const CreateDocumentTemplateSchema = yup.object({
  type: yup.string().required(),
  information: yup.string().notRequired().nullable(),
  originDate: yup.date().required(),
});

export interface IDocumentTemplateCreate {
  type: DocumentTemplateType;
  information: string | null;
  originDate: Date;
}

export interface IDocumentTemplate {
  id: string;
  type: string;
  information: string | null;
  originDate: Date;
  createdAt: Date;
  fileName: string;
  awsFilePath: string;
  isHidden: boolean;
}

export interface IUpdateDocumentTemplate extends IDocumentTemplateCreate {
  id: string;
  isHidden: boolean;
}
